import React from "react";
import { Grid, Button } from "@mui/material";
import coClientSVG from "../../assets/CoClient-02.svg";
import familyMemberSVG from "../../assets/Family Members-03.svg";
import selectedSVG from "../../assets/Selected-09.svg";

const SelectParticipantStep = (props) => {
  const participantButtonClass = (field) => {
    return props.state[field]
      ? "participant-button active"
      : "participant-button";
  };

  return (
    <Grid container spacing={3} justifyContent="center">
      <Grid item xs={8}></Grid>
      <Grid item xs={4}>
        <div className={"client-wizard-buttons"}>
          <Button color={"primary"} variant={"contained"} onClick={props.next}>
            Next
          </Button>
        </div>
      </Grid>
      {!props.state.hasCoClient && (
        <Grid item xs={4}>
          <div
            className={participantButtonClass("addCoClient")}
            onClick={() => {
              props.setState({
                ...props.state,
                addCoClient: !props.state.addCoClient,
              });
            }}
          >
            {!props.state.addCoClient && (
              <img
                src={coClientSVG}
                alt={"Add Co-Client"}
                title={"Add Co-Client"}
              />
            )}
            {props.state.addCoClient && (
              <img
                src={selectedSVG}
                alt={"Add Co-Client"}
                title={"Add Co-Client"}
              />
            )}
            <label>Co-Client</label>
          </div>
        </Grid>
      )}
      <Grid item xs={4}>
        <div
          className={participantButtonClass("addFamilyMember")}
          onClick={() => {
            console.log("previous to save family");
            console.log(props.state);
            props.setState({
              ...props.state,
              addFamilyMember: !props.state.addFamilyMember,
            });
          }}
        >
          {!props.state.addFamilyMember && (
            <img
              src={familyMemberSVG}
              alt={"Add Family Member"}
              title={"Add Family Member"}
            />
          )}
          {props.state.addFamilyMember && (
            <img
              src={selectedSVG}
              alt={"Add Family Member"}
              title={"Add Family Member"}
            />
          )}
          <label>Family Member</label>
        </div>
      </Grid>
      <Grid item xs={4}>
        <div
          className={participantButtonClass("addOther")}
          onClick={() => {
            props.setState({
              ...props.state,
              addOther: !props.state.addOther,
            });
          }}
        >
          {!props.state.addOther && (
            <img
              src={familyMemberSVG}
              alt={"Add Other Member"}
              title={"Add Other Member"}
            />
          )}
          {props.state.addOther && (
            <img
              src={selectedSVG}
              alt={"Add Other Member"}
              title={"Add Other Member"}
            />
          )}
          <label>Other Member</label>
        </div>
      </Grid>
    </Grid>
  );
};

export default SelectParticipantStep;
